export default "__VITE_PUBLIC_ASSET__fbdc40d9__"